import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, TimePicker, DatePicker } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import ImageUpload from '../../utils/ImageUpload';
import { addModules, getModules } from '../../feature/modules/moduleSlice';
import { addRelationType, getRelationType } from '../../feature/relation/RelationTypeSlice';



function AddRelationType() {
    const { actionLoader } = useSelector((state) => state.relations);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    const onFinish = async (values) => {

        const resultAction = await dispatch(addRelationType(values));
        if (addRelationType.fulfilled.match(resultAction)) {
            await dispatch(getRelationType({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("Add relation");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >

            <Form.Item
                name="relationCode"
                label="Relation"
                rules={[{ required: true, message: 'Please enter  relation name ' }]}
            >
                <Input placeholder='Enter Relation' />
            </Form.Item>

            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const AddConsultationProps = {
        open,
        setOpen,
        title: 'Add New Relation',
        action: 'Add',
        content: AddForm,
    };

    return (
        <section>
            <AddDrawer {...AddConsultationProps} />
        </section>
    );
}



export default AddRelationType